module.exports = __webpack_public_path__ + "static/media/Commercial-13.620540ad.jpg";